import { createBrowserHistory } from 'history'
import { applyMiddleware, compose, createStore } from 'redux'
import { createRouterMiddleware } from '@lagunovsky/redux-react-router'
import createRootReducer from './createRootReducer'
import {composeWithDevTools} from "redux-devtools-extension";
import thunk from "redux-thunk";

export const history = createBrowserHistory();

const middleware = [
    createRouterMiddleware(history), // for dispatching history actions
    thunk,
];

if (process.env.REACT_APP_OPENREPLAY_PROJECT_ID && window.tracker) {
    try {
        const trackerRedux = require('@openreplay/tracker-redux/cjs').default;
        middleware.push(window.tracker.use(trackerRedux()));
    } catch (e) {
        console.warn('Failed to initialize OpenReplay Redux tracker:', e);
    }
}

export default function configureStore(preloadedState) {
    return createStore(
        createRootReducer(history), // root reducer with router state
        preloadedState,
        compose(
            composeWithDevTools(
                applyMiddleware(...middleware),
            )
        ),
    );
}